// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IReissueDecision } from './IReissueDecision';
import {
    instanceOfIReissueDecision,
    IReissueDecisionFromJSON,
    IReissueDecisionFromJSONTyped,
    IReissueDecisionToJSON,
} from './IReissueDecision';
import type { IVoidDecision } from './IVoidDecision';
import {
    instanceOfIVoidDecision,
    IVoidDecisionFromJSON,
    IVoidDecisionFromJSONTyped,
    IVoidDecisionToJSON,
} from './IVoidDecision';

/**
 * @type IReturnedCheckDetailsAllOfProcessingDecision
 * 
 * @export
 */
export type IReturnedCheckDetailsAllOfProcessingDecision = IReissueDecision | IVoidDecision;

export function IReturnedCheckDetailsAllOfProcessingDecisionFromJSON(json: any): IReturnedCheckDetailsAllOfProcessingDecision {
    return IReturnedCheckDetailsAllOfProcessingDecisionFromJSONTyped(json, false);
}

export function IReturnedCheckDetailsAllOfProcessingDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnedCheckDetailsAllOfProcessingDecision {
    if (json == null) {
        return json;
    }
    if (typeof json !== 'object') {
        return json;
    }
    if (instanceOfIReissueDecision(json)) {
        return IReissueDecisionFromJSONTyped(json, true);
    }
    if (instanceOfIVoidDecision(json)) {
        return IVoidDecisionFromJSONTyped(json, true);
    }

    return {} as any;
}

export function IReturnedCheckDetailsAllOfProcessingDecisionToJSON(json: any): any {
    return IReturnedCheckDetailsAllOfProcessingDecisionToJSONTyped(json, false);
}

export function IReturnedCheckDetailsAllOfProcessingDecisionToJSONTyped(value?: IReturnedCheckDetailsAllOfProcessingDecision | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    if (typeof value !== 'object') {
        return value;
    }
    if (instanceOfIReissueDecision(value)) {
        return IReissueDecisionToJSON(value as IReissueDecision);
    }
    if (instanceOfIVoidDecision(value)) {
        return IVoidDecisionToJSON(value as IVoidDecision);
    }

    return {};
}

